import _ from "lodash";

export const useWadAuth = () => {

  const {status, data: userData} = useAuth();

  const userLoggedIn = computed(() => {
    return status.value === 'authenticated';
  });

  const currentUserId = computed(() => {
    return userLoggedIn.value ? userData.value?.data.id : undefined;
  })

  const currentUserSseTopics = computed(() => {
    return userLoggedIn.value ? userData.value?.data.sse_topics : [];
  })

  const requireEmailVerification = computed(() => {
    return userLoggedIn.value ? !userData.value?.data.verification : false;
  })

  const getEventUserInfo = (eventId: number): EventUserInfo|null => {
    if(userLoggedIn.value && eventId) {
      return userData.value?.data.events_with_ticket?.find((e: EventUserInfo) => e.id === eventId) ?? null;
    }
    return null;
  }

  const hasEventTicket = (eventId: number): boolean => {
    return !!getEventUserInfo(eventId);
  }

  const needsOnboarding = (eventId: number): boolean => {
    if (!userLoggedIn.value || !eventId) {
      return false;
    }
    const event = getEventUserInfo(eventId);
    return !!event?.require_onboarding;
  }

  // Partner ticket holders can only scan leads once their manager adds them as a
  // related person in the WAD portal (which grants app.scan-leads). Until then the
  // app warns them during onboarding and on the attendee QR scanner.
  const needsLeadScanningWarning = (eventId: number): boolean => {
    const event = getEventUserInfo(eventId);
    return !!event?.is_partner_ticket && !hasPermission('app.scan-leads');
  }

  const hasPermission = (permission: string | string[]): boolean => {
    const permissions =userData.value?.data.permissions || [];
    const requested = Array.isArray(permission) ? permission : [permission]
    return _.intersection(permissions, requested).length > 0
  }

  return {
    userLoggedIn,
    currentUserId,
    currentUserSseTopics,
    requireEmailVerification,
    getEventUserInfo,
    hasEventTicket,
    hasPermission,
    needsOnboarding,
    needsLeadScanningWarning,
  }
}
